import React, { Component } from 'react'
import IPropTypes from 'react-immutable-proptypes'
import { connect } from 'react-redux'
import { Map } from 'immutable'

import config from '../../../../../../config'

const MODULE_KEY = config.modules.portfolio.key

function mapStateToProps(state) {
    const activePortfolioType = state.getIn(['ui', 'modules', MODULE_KEY, 'ribbon', 'portfolios', 'active'], null)

    const buttons = state.getIn(
        ['authorization', 'accessRights', MODULE_KEY, 'custom', 'portfolios', activePortfolioType, 'blocks'],
        Map()
    )
    const sortedButtons = buttons
        .toList()
        .sortBy((b) => b.get('order'))
        .map((b) => Map({ name: b.get('name'), disabled: b.get('isDisabled') }))

    const portfolios = state.getIn(['authorization', 'accessRights', MODULE_KEY, 'custom', 'portfolios'], Map())
    const allowedPortfolios = portfolios
        .toList()
        .sortBy((b) => b.get('order'))
        .filter((b) => b.get('isAllowed'))
        .map((b) =>
            Map({
                name: b.get('name'),
                disabled: b.get('isDisabled'),
            })
        )

    return {
        buttons: sortedButtons,
        portfolios: allowedPortfolios,
    }
}

export default function (InnerComponent) {
    @connect(mapStateToProps)
    class HocConnect extends Component {
        static propTypes = {
            buttons: IPropTypes.list.isRequired,
            portfolios: IPropTypes.list.isRequired,
        }

        shouldComponentUpdate(nextProps) {
            if (!this.props.buttons.equals(nextProps.buttons)) return true
            if (!this.props.portfolios.equals(nextProps.portfolios)) return true
            return false
        }

        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
